import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useOverlayTriggerState as $9Xvoh$useOverlayTriggerState } from "@react-stately/overlays";
import { useState as $9Xvoh$useState } from "react";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $a28c903ee9ad8dc5$exports = {};
$parcel$export($a28c903ee9ad8dc5$exports, "useMenuTriggerState", function () {
  return $a28c903ee9ad8dc5$export$79fefeb1c2091ac3;
});

function $a28c903ee9ad8dc5$export$79fefeb1c2091ac3(props) {
  var overlayTriggerState = $9Xvoh$useOverlayTriggerState(props);

  var _$9Xvoh$useState = $9Xvoh$useState(null),
      _$9Xvoh$useState2 = _slicedToArray(_$9Xvoh$useState, 2),
      focusStrategy1 = _$9Xvoh$useState2[0],
      setFocusStrategy = _$9Xvoh$useState2[1];

  return _objectSpread(_objectSpread({
    focusStrategy: focusStrategy1
  }, overlayTriggerState), {}, {
    open: function open() {
      var focusStrategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      setFocusStrategy(focusStrategy);
      overlayTriggerState.open();
    },
    toggle: function toggle() {
      var focusStrategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      setFocusStrategy(focusStrategy);
      overlayTriggerState.toggle();
    }
  });
}

export { $a28c903ee9ad8dc5$export$79fefeb1c2091ac3 as useMenuTriggerState };